module.exports = __webpack_public_path__ + "img/pr-1.7aa92d84.png";